import { Button } from "@mui/material";
import useResponsive from "../../../../Hooks/useResponsive";

export const CustomButton = ({
  sx,
  onClick,
  children,
  color,
  size,
  variant,
}) => {
  const mdUp = useResponsive("up", "md");
  const textSize = mdUp ? "0.7rem" : "0.65rem";
  const buttonSize = mdUp ? 28 : 22;
  return (
    <Button
      color={color || "primary"}
      size={size || "small"}
      sx={{
        height: buttonSize,
        whiteSpace: "nowrap",
         minWidth: 80,
        boxShadow: "none",
        borderRadius: 0.5,
        fontSize: textSize,
        ...sx,
      }}
      variant={variant || "outlined"}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
